<section class="file-uploader">
  <div
    class="file-upload file-upload-field"
    ngFileDrop
    (uploadOutput)="onUploadOutput($event)"
    [uploadInput]="uploadInput"
    [ngClass]="{ 'is--drop-over': dragOver }"
  >
    <label class="button variant-dark-color">
      <span class="icon icon--left is--icon-plus">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
        </svg>
      </span>
      <input class="is--hidden" type="file" ngFileSelect (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" multiple />
      Add File(s)
    </label>

    <div class="file-upload-dropzone-label">
      or
      <span class="icon icon--left is--icon-upload">
        <svg class="icon-svg">
          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-upload"></use>
        </svg>
      </span>
      drop file(s)
    </div>
  </div>
  <ul class="file-uploader-list" ngxDroppable [model]="files">
    <!--<li class="file-uploader-list-item" [ngClass]="{'is--uploaded' : file.progress.data.percentage == 100}" *ngFor="let file of filesToUpload" (click)="file.selected = !file.selected">
            <figure class="file">
                <figcaption class="file-meta">
                    <ul class="file-meta-list">
                        <li class="file-meta-item"><strong>{{file.name}}</strong></li>
                    </ul>
                    <span class="icon icon--left is--icon-check">
                        <svg class="icon-svg ">
                            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                        </svg>
                    </span>
                </figcaption>
            </figure>
        </li>-->

    <li
      class="file-uploader-list-item"
      [ngClass]="{ 'is--selected': file.selected }"
      *ngFor="let file of files"
      [model]="file"
      (click)="file.selected = !file.selected"
      ngxDraggable
    >
      <figure class="file">
        <img class="" [src]="file.ImageUrl + '?w=300&h=300&mode=crop'" *ngIf="file.ImageUrl" />
        <div class="file-meta-caption" *ngIf="file.Caption">
          <span class="icon is--icon-info">
            <svg class="icon-svg">
              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-info"></use>
            </svg>
          </span>
          <li class="file-meta-caption-text">
            <strong>{{ file.Caption }}</strong>
          </li>
        </div>
        <figcaption class="file-meta">
          <ul class="file-meta-list">
            <li class="file-meta-item" *ngIf="file.Progress < 100">
              <strong>{{ file.Filename }}</strong>
            </li>
            <li class="file-meta-item" *ngIf="file.Progress < 100">
              <strong>{{ file.Progress }}</strong>
              <span class="type-small">%</span>
            </li>
            <li class="file-meta-item">
              <strong>{{ phaseLookup[file.Phase] }}</strong>
            </li>
            <li class="file-meta-item">
              <strong>{{ file.Category }}</strong>
            </li>
            <li class="file-meta-item">
              <span *ngIf="file.UsedInArchive" class="file-meta-item-tag">Archive</span>
              <span *ngIf="file.UsedInWebsite" class="file-meta-item-tag">Website</span>
              <span *ngIf="file.UsedInPressKit" class="file-meta-item-tag">Press kit</span>
              <span *ngIf="file.UsedAsWebsiteMainImage" class="file-meta-item-tag">Main Image</span>
            </li>
          </ul>
          <span class="icon icon--left is--icon-check">
            <svg class="icon-svg">
              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
            </svg>
          </span>
        </figcaption>
      </figure>
    </li>
  </ul>

  <footer class="file-uploader-options" [ngClass]="{ 'is--selected': filesSelected().length > 0 }" *ngIf="files?.length > 0">
    <div class="upload-options-item col-1-2">
      <label for="file-phase" class="required wizard-label">Phase</label>
      <div class="switch-select">
        <span class="icon is--icon-angle-down">
          <svg class="icon-svg">
            <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
          </svg>
        </span>
        <select name="file-phase" [disabled]="filesSelected().length <= 0" [(ngModel)]="fileBlueprint.Phase">
          <option value="0">Make a choice</option>
          <option value="1">Competition</option>
          <option value="2">Design</option>
          <option value="3">In progress</option>
          <option value="4">On site</option>
          <option value="5">Realized</option>
        </select>
      </div>
    </div>
    <div class="upload-options-item col-1-2">
      <label for="file-category" class="required wizard-label">Category</label>
      <div class="switch-select">
        <span class="icon is--icon-angle-down">
          <svg class="icon-svg">
            <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
          </svg>
        </span>
        <select name="file-category" [disabled]="filesSelected().length <= 0" [(ngModel)]="fileBlueprint.Category">
          <option value="">Make a choice</option>
          <option value="Render">Render</option>
          <option value="Photo">Photo</option>
          <option value="Construction drawing">Construction drawing</option>
          <option value="Floorplan">Floorplan</option>
        </select>
      </div>
    </div>
    <div class="upload-options-item col-wide">
      <label for="file-caption" class="required wizard-label">Caption</label>
      <input type="text" name="file-caption" [disabled]="filesSelected().length <= 0" [(ngModel)]="fileBlueprint.Caption" />
    </div>
    <div class="upload-options-item col-wide">
      <label for="file-caption-cn" class="required wizard-label">Caption (Chinese)</label>
      <input type="text" name="file-caption-cn" [disabled]="filesSelected().length <= 0" [(ngModel)]="fileBlueprint.Caption_CN" />
    </div>
    <div class="upload-options-item col-wide">
      <label for="field_image" class="required wizard-label">File visible in:</label>
      <ul class="form-col-list">
        <li class="form-col-item">
          <input
            required="required"
            class=""
            id="id_archive"
            name="archive"
            value=""
            [(ngModel)]="fileBlueprint.UsedInArchive"
            data-error-message="Dit veld is verplicht"
            type="checkbox"
            [disabled]="filesSelected().length <= 0"
          />
          <label for="id_archive">
            <span class="icon is--icon-check">
              <svg class="icon-svg">
                <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
              </svg>
            </span>
            Archive
          </label>
        </li>
        <li class="form-choice-item">
          <input
            required="required"
            class=""
            id="id_website"
            name="website"
            value=""
            [(ngModel)]="fileBlueprint.UsedInWebsite"
            data-error-message="Dit veld is verplicht"
            type="checkbox"
            [disabled]="filesSelected().length <= 0"
          />
          <label for="id_website">
            <span class="icon is--icon-check">
              <svg class="icon-svg">
                <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
              </svg>
            </span>
            Website
          </label>
        </li>
        <!-- <li class="form-choice-item">
                <input required="required" class="" id="id_presskit" name="presskit" value="" [(ngModel)]="fileBlueprint.UsedInPressKit" data-error-message='Dit veld is verplicht'
                  type="checkbox" [disabled]="filesSelected().length <= 0">
                <label for="id_presskit">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                          <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    Press kit
                </label>
              </li> -->
        <li class="form-choice-item">
          <input
            required="required"
            class=""
            id="id_main-image"
            name="main-image"
            value=""
            [(ngModel)]="fileBlueprint.UsedAsWebsiteMainImage"
            data-error-message="Dit veld is verplicht"
            type="checkbox"
            [disabled]="filesSelected().length <= 0 || filesSelected().length > 1"
          />
          <label for="id_main-image">
            <span class="icon is--icon-check">
              <svg class="icon-svg">
                <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
              </svg>
            </span>
            Website (Main Image)
          </label>
        </li>
      </ul>
    </div>
    <div class="col-wide upload-options-buttons button-group">
      <button class="button variant-dark-color type-file-apply" [disabled]="filesSelected().length <= 0" (click)="setFileProperties()">
        <span class="icon icon--left is--icon-plus">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
          </svg>
        </span>
        Apply selected file(s)
      </button>

      <button
        type="button"
        class="button variant-dark-color type-file-delete"
        [disabled]="filesSelected().length <= 0"
        (click)="deleteFile()"
      >
        <span class="icon icon--left is--icon-cross">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-cross"></use>
          </svg>
        </span>
        Delete selected file(s)
      </button>
    </div>
  </footer>
</section>
